export enum BatchTabs {
  POSITIONS = 'positions',
  LOGISTICS = 'logistics',
  COSTS     = 'costs'
}
